import { EMCType } from "../enums/emc-type";
import { EntityModelConfiguration } from "../enums/entityModelConfiguration";

export class GetEMCConfigurationDataIn {
    type!: EMCType;
    utilityId: number | null = null;
    substationTemplateId?: number;
}

export class SaveConfigurationDataIn {
    type!: EMCType;
    utilityId!: number;
    configuration!: EntityModelConfiguration[];
    substationTemplateId?: number;
}
